import { render, staticRenderFns } from "./AdditionalDetails.vue?vue&type=template&id=da1e1eee&scoped=true"
import script from "./AdditionalDetails.vue?vue&type=script&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDetails.vue?vue&type=style&index=0&id=da1e1eee&prod&lang=scss"
import style1 from "./AdditionalDetails.vue?vue&type=style&index=1&id=da1e1eee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1e1eee",
  null
  
)

export default component.exports